import { StyleSheet, Text, View } from "react-native";
import { Button } from "@platform/ui";

export function HomeScreen() {
  return (
    <View style={styles.container}>
      <Text style={styles.title}>Welcome</Text>
      <Text style={styles.subtitle}>This view is shared by web, Android, and iOS.</Text>
      <Button label="Continue" onPress={() => undefined} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    gap: 12,
    justifyContent: "center",
    padding: 24,
  },
  title: {
    color: "#172026",
    fontSize: 28,
    fontWeight: "700",
  },
  subtitle: {
    color: "#53625d",
    fontSize: 16,
    marginBottom: 8,
  },
});